import React, { useState } from 'react'
import { Form, Button, Row, Col } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { SHA256 } from 'utils/SHA256';
import logo from 'static/images/logo/kumhoPetro.png';

import './LoginForm.css';

const LoginForm = ({ handleLogin, isLoggedIn }) => {
  const { register, handleSubmit, errors } = useForm();

  const onSubmit = (data) => {
    if (loginValidation(data)) {
      handleLogin(data.userId, SHA256(data.userPw));
    }
  }

  const loginValidation = ({ userId, userPw }) => {
    if (userId === null || userId === "") {
      alert("아이디를 입력해주세요.");
      return false;
    }
    if (userPw === null || userPw === "") {
      alert("비밀번호를 입력해주세요.");
      return false;
    }

    return true;
  }

  return (
    <>
      <div className="loginFormHeader">
        {/* <img src={logo} alt="logo" /> */}
        <p className="logo">UBi<span className="logoColorOrange">T</span>OMS<span className="logoColorBlack">™</span></p>
        <p className="logoDetail">UBiquitous Total Operation Monitoring and managing System</p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="loginForm">
          <Form.Group as={Row} controlId="formBasicEmail">
            <Col>
              <input type="text"
                placeholder="아이디"
                name="userId"
                ref={register} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="formBasicuserPw">
            <Col>
              <input type="password"
                placeholder="비밀번호"
                name="userPw"
                ref={register} />
            </Col>
          </Form.Group>
          <div className="autoLoginBox">
          </div>
          <Button variant="primary" type="submit" block>
            Log in
          </Button>
        </div>
      </form>
    </>
  );
}

export default LoginForm;